import * as React from 'react';

const Warning = ({ className = '', strokeColor = '#E02424' }) => (
  <svg width={22} height={20} viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M10.9999 7.99999V11.75M1.69694 15.126C0.830943 16.626 1.91394 18.5 3.64494 18.5H18.3549C20.0849 18.5 21.1679 16.626 20.3029 15.126L12.9489 2.37799C12.0829 0.877991 9.91694 0.877991 9.05094 2.37799L1.69694 15.126ZM10.9999 14.75H11.0069V14.758H10.9999V14.75Z"
      stroke={strokeColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Warning;
